<template>
  <div class="page">
    <div class="mian">
      <div :style="display">
        <h3>下载模板</h3>
        <div style="font-size: 12px; margin-bottom: 10px">
          为提高导入成功率，请下载并使用系统的模板
        </div>
        <el-button size="small" @click="handleExportTemplate">下载模板</el-button>
      </div>
      <div>
        <h3>上传文件</h3>
        <el-upload
          :on-change="handleChange"
          :headers="headers"
          class="upload-demo"
          ref="upload"
          :action="action"
          :on-remove="handleRemove"
          :on-success="handleSuccess"
          :on-error="handleError"
          :file-list="fileList"
          :auto-upload="false"
          :data="{orgID:uploadOrgID}"
        >
          <el-button slot="trigger" size="small" type="primary"
            >选取文件</el-button
          >
          <el-button
            :loading="loading"
            style="margin-left: 10px;"
            size="small"
            type="success"
            @click="submitUpload"
            >{{ loading ? "导入中..." : "开始导入" }}</el-button
          >
        </el-upload>
          <i style="color:grey;margin-top: 10px; font-size: 12px; " class="el-icon-warning-outline"> 文件最大不超过5MB</i>
      </div>
    </div>

    <el-dialog
      :visible.sync="showUploadInfo"
      :modal="false"
      style="margin-top: 50px;"
      :close-on-click-modal="false"
      title="导入结果"
    >
      <div>
        <div>
          数据总条数：{{ uploadFile.totalNum }}，
          导入总条数：{{ uploadFile.importedNum }}，
          失败总条数：{{ uploadFile.failedNum }}
        </div>
        <div v-if="uploadFile.failedNum > 0">具体错误参见导出的Excel文件 </div>
        <!-- <el-table
          :data="uploadFile.failedList"
          style="width: 100%; margin-top: 20px"
          v-if="uploadFile.failedNum > 0"
        >
          <el-table-column prop="row" label="行号" align="center">
          </el-table-column>
          <el-table-column prop="reason" label="失败原因" align="center">
          </el-table-column>
        </el-table> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import mixins from "../../minix";

export default {
  name: "file-upload",

  props: {
    type: String,
    orgID: String,
    file: String
  },

  mixins: [mixins],

  data() {
    return {
      display: "",
      downloadUrl: "",
      headers: {},
      loading: false,
      uploadOrgID:"",
      action: "",
      showUploadInfo: false,
      fileList: [],
      uploadFile: {}
    };
  },

  created() {
    let type = this.$route.query.type;
    let orgID = this.$route.query.orgID;
    document.title = type || "";

    //URl没有数据的时候，才获取组件传进来的数据
    if (!type) {
      Utils.userInfo.type = this.type;
      Utils.userInfo.file = this.file;
      type = this.type;

      //没有数据时不变  使用this.orgID 即传递进来的数据
      Utils.userInfo.orgID = this.orgID;
    } else {
      // url有数据时 使用url里的数据
      Utils.userInfo.type = this.$route.query.type;
      Utils.userInfo.file = this.$route.query.file;
      Utils.userInfo.orgID = this.$route.query.orgID;



      localStorage.setItem("token", this.$route.query.token || "");
      localStorage.setItem("orgID", this.$route.query.orgID || "");
      localStorage.setItem("type", "Web_Admin");
    }
    this.uploadOrgID =Utils.userInfo.orgID 

    this.headers = {
      Authorization: localStorage.getItem("token"),
      "PYDDot-Client-Type": "Web_Admin",
      "PYDDot-Org-ID": localStorage.getItem("orgID"),
      "X-Ca-Timestamp": parseInt(Date.now() / 1000)
    };
    // this.data={
    //   orgID:this.uploadOrgID
    // }

    if (type === "房源导入") {
      this.action = axios.defaults.baseURL + "houses/import";
    } else if (type === "租约导入") {
      this.action = axios.defaults.baseURL + "leases/import";
    } else if (type == "2021年前租约导入") {
      this.action = axios.defaults.baseURL + "leases/importprev";
    } else if (type === "水电导入") {
      this.action = axios.defaults.baseURL + "meters/records/import";
    } else if (type === "付款信息导入") {
      this.action = axios.defaults.baseURL + "bills/comments/import";
    }else if (type === "银行账单信息导入") {
      this.action = axios.defaults.baseURL + "banks/records/import";
      this.display="display:none;" //将模板下载隐藏
    } else if (type === "新版租约导入") {
      this.action = axios.defaults.baseURL + "leases/importnew";
    } else {
      console.error('未知的导入类型')
    }

    this.downloadUrl = axios.defaults.baseURL.replace(
      "v1/org/",
      "public/" + Utils.userInfo.file
    );
  },

  methods: {
    submitUpload() {
      if (this.fileList.length <= 0) {
        this.$message.error("请选择导入文件");
        return;
      }
      this.loading = true;
      this.$refs.upload.submit();
    },

    //导出模板
    handleExportTemplate() {
      axios({
        method: "get",
        url: this.downloadUrl,
        responseType: "blob"
      })
        .then(value => {
          Utils.convertRes2Blob(Utils.userInfo.file, value);
          this.$message.success("文件下载成功");
        })
        .catch(e => {
          this.$message.error(e.toString());
        });
    },

    handleRemove() {
      this.fileList = [];
    },

    handleChange(file, fileList) {
      fileList = fileList || [];
      if (fileList.length > 1) {
        fileList.shift();
        this.$message.error("最多可以导入一个文件");
      }
      this.fileList = fileList;
    },

    handleError() {
      this.loading = false;
      this.$refs.upload.clearFiles();

      this.$alert("导入失败，请检查文件格式是否正确，或文件大小是否超出限制。", Utils.userInfo.type, {
        type: "error",
        confirmButtonText: "确定",
        callback: () => {}
      });
    },

    handleSuccess(response) {
      this.loading = false;
      this.$refs.upload.clearFiles();

      if (response.code === 0) {
        this.showUploadInfo = true;
        this.uploadFile = response.data;
      } else {
        this.$alert(response.message, Utils.userInfo.type, {
          type: "error",
          confirmButtonText: "确定",
          callback: () => {}
        });
      }

      if (response.filename) {
        let url = axios.defaults.baseURL.replace(
          "v1/org/",
          "public/" + response.filename
        );
        axios({
          method: "get",
          url: url,
          responseType: "blob"
        })
          .then(value => {
            Utils.convertRes2Blob(response.filename, value);
          })
          .catch(e => {
            this.$message.error(e.toString());
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../style.css";
.main {
  margin-left: 30%;
  width: 40%;
  text-align: left;
  min-height: 130px;

  display: flex;
  flex-direction: column;
}
</style>
